import React from "react";
import './SkynetAnchor.css'

const AnchorTarget = {
    DEFAULT: '_self',
    BLANK: '_blank',
}
    
export const SkynetAnchor = ({ children, onClick, target = AnchorTarget.DEFAULT, disabled }) => {
    return <a role='link' target={target} className={`${disabled ? 'disabled' : ''}`} onClick={onClick}>
        {children}
    </a>
}